import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
} from '@angular/core';

declare var google: any;

@Directive({
    selector: '[ngx-google-places-autocomplete]',
    exportAs: 'ngx-places',
    standalone: false
})
export class GooglePlaceDirective implements AfterViewInit {
  @Input('options') options: any;
  @Output() onAddressChange: EventEmitter<any> = new EventEmitter();

  private autocomplete: any;
  public place: any;

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    if (!this.options) {
      this.options = {};
    }
    this.initialize();
  }

  private isGoogleLibExists(): boolean {
    return typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.places !== 'undefined';
  }

  private initialize(): void {
    if (!this.isGoogleLibExists()) {
      throw new Error('Google maps library can not be found');
    }

    this.autocomplete = new google.maps.places.Autocomplete(
      this.el.nativeElement,
      this.options
    );

    if (this.autocomplete.addListener != null) {
      this.autocomplete.addListener('place_changed', () => {
        this.handleChangeEvent();
      });
    }

    this.el.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
      if (!event.key) {
        return;
      }
      const key = event.key.toLowerCase();
      if (key === 'enter' && event.target === this.el.nativeElement) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  public reset(): void {
    this.autocomplete.setComponentRestrictions(this.options.componentRestrictions);
    this.autocomplete.setTypes(this.options.types);
  }

  private handleChangeEvent(): void {
    this.ngZone.run(() => {
      this.place = this.autocomplete.getPlace();
      if (this.place) {
        this.onAddressChange.emit(this.place);
      }
    });
  }
}
